import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchitectureWindow1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "architecture-window-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.25,21.75a1.5,1.5,0,0,1-1.5,1.5h-15a1.5,1.5,0,0,1-1.5-1.5v-12a9,9,0,0,1,18,0Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.25,
			y1: 9.75,
			x2: 21.25,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.25,
			y1: 15.75,
			x2: 21.25,
			y2: 15.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.25,
			y1: 9.75,
			x2: 12.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.25,
			y1: 9.75,
			x2: 9.25,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.25,
			y1: 9.75,
			x2: 15.25,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.56,
			y1: 3.729,
			x2: 12.25,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18.94,
			y1: 3.729,
			x2: 12.25,
			y2: 9.75
		})
	]
});
export default SvgArchitectureWindow1;
